export function Improve() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.25 3.5C12.25 2.53347 13.0335 1.75 14 1.75C13.0335 1.75 12.25 0.9665 12.25 0C12.25 0.966471 11.4665 1.75 10.5 1.75C11.4664 1.75 12.25 2.53344 12.25 3.5Z"
        fill="black"
      />
      <path
        d="M12.25 3.5C12.25 2.53347 13.0335 1.75 14 1.75C13.0335 1.75 12.25 0.9665 12.25 0C12.25 0.966471 11.4665 1.75 10.5 1.75C11.4664 1.75 12.25 2.53344 12.25 3.5Z"
        fill="url(#paint0_linear_8_19)"
      />
      <path
        d="M12.6875 5.24997C12.6875 5.97483 12.0998 6.56246 11.375 6.56246C12.0999 6.56246 12.6875 7.15009 12.6875 7.87496C12.6875 7.15007 13.2751 6.56246 14 6.56246C13.2751 6.56249 12.6875 5.97486 12.6875 5.24997Z"
        fill="black"
      />
      <path
        d="M12.6875 5.24997C12.6875 5.97483 12.0998 6.56246 11.375 6.56246C12.0999 6.56246 12.6875 7.15009 12.6875 7.87496C12.6875 7.15007 13.2751 6.56246 14 6.56246C13.2751 6.56249 12.6875 5.97486 12.6875 5.24997Z"
        fill="url(#paint1_linear_8_19)"
      />
      <path
        d="M6.12499 5.24997C6.12499 3.80022 7.30022 2.62499 8.74997 2.62499C7.30022 2.62499 6.12499 1.44975 6.12499 0C6.12499 1.44975 4.94975 2.62499 3.5 2.62499C4.94975 2.62499 6.12499 3.80025 6.12499 5.24997Z"
        fill="black"
      />
      <path
        d="M6.12499 5.24997C6.12499 3.80022 7.30022 2.62499 8.74997 2.62499C7.30022 2.62499 6.12499 1.44975 6.12499 0C6.12499 1.44975 4.94975 2.62499 3.5 2.62499C4.94975 2.62499 6.12499 3.80025 6.12499 5.24997Z"
        fill="url(#paint2_linear_8_19)"
      />
      <path
        d="M9.62499 2.625L0 12.25L1.75 14L11.375 4.375L9.62499 2.625ZM8.13133 5.43115L9.36861 4.19386L9.80612 4.63137L8.56883 5.86866L8.13133 5.43115Z"
        fill="black"
      />
      <path
        d="M9.62499 2.625L0 12.25L1.75 14L11.375 4.375L9.62499 2.625ZM8.13133 5.43115L9.36861 4.19386L9.80612 4.63137L8.56883 5.86866L8.13133 5.43115Z"
        fill="url(#paint3_linear_8_19)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8_19"
          x1="12.25"
          y1="0"
          x2="12.25"
          y2="3.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EC6181" />
          <stop offset="1" stopColor="#5C69E3" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8_19"
          x1="12.6875"
          y1="5.24997"
          x2="12.6875"
          y2="7.87496"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EC6181" />
          <stop offset="1" stopColor="#5C69E3" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_8_19"
          x1="6.12499"
          y1="0"
          x2="6.12499"
          y2="5.24997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EC6181" />
          <stop offset="1" stopColor="#5C69E3" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_8_19"
          x1="5.68749"
          y1="2.625"
          x2="5.68749"
          y2="14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EC6181" />
          <stop offset="1" stopColor="#5C69E3" />
        </linearGradient>
      </defs>
    </svg>
  );
}
